




































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/customer-header.vue";
import { GetKepuDetail, GetFeedbackAll } from "@/request/common";
import Fankui from "@/components/fankui.vue";
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);
@Component({
  components: {
    MainHeader,
    Fankui,
  },
})
export default class Name extends Vue {
  private data: any = {};
  private showFankui: any = false;
  private fankuiData: any = [];
  private path: any = "";
  private canGo: any = false;
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private cancelFankui() {
    this.showFankui = false;
    this.canGo = true;
    this.$router.push(this.path);
  }
  private sureFankui() {
    this.showFankui = false;
    this.canGo = true;
    this.$router.push(this.path);
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetKepuDetail(this, this.data.id, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
      })
      .catch(() => {
        loading.close();
      });
  }
  private getFankuiData() {
    const params: any = {
      params: {
        creator: this.user.userId,
      },
    };
    GetFeedbackAll(this, params).then((res: any) => {
      this.fankuiData = res.data;
      if (this.fankuiData.length == 0) {
        this.canGo = false;
      } else {
        this.canGo = true;
      }
    });
  }
  private mounted() {
    this.getFankuiData();
    if (this.$route.query.id) {
      this.data.id = this.$route.query.id;
      this.getData();
    }
  }
  /**
   * @description 离开页面前保存
   */
  private beforeRouteLeave(to: any, from: any, next: any) {
    this.path = to.fullPath;
    if (!this.canGo) {
      this.showFankui = true;
      next(false);
    } else {
      next(true);
    }
  }
}
